import { IntegrationService } from '../../../../../../services/exports/Constants';

export default {
  title: 'Integrações',
  services: {
    [IntegrationService.Tabless]: 'Tabless',
    [IntegrationService.WinOrder]: 'WinOrder',
    [IntegrationService.ExpertOrder]: 'ExpertOrder',
    [IntegrationService.Deliverect]: 'Deliverect',
    [IntegrationService.Liefersoft]: 'Liefersoft',
    [IntegrationService.Hubrise]: 'HubRise',
  },
  labels: {
    no_integrations: '{{company}} não tem integrações configuradas.',
  },
  buttons: {
    add_integration: 'Adicionar integração',
  },
  toasts: {
    error: 'Erro ao guardar as alterações',
    success: 'Alterações guardadas',
    load_error: 'Erro ao carregar integrações',
  },
};
